/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormField, FormItem, FormLabel, FormDescription, FormMessage } from "@/shared/components/ui/form"
import { Input } from "@/shared/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select"
import { useTranslation } from "react-i18next"
import { Control } from "react-hook-form"
import { getArrayItemFields } from "../utils/arrayItemFields"

interface ArrayFieldItemFormProps {
  field: any
  index: number
  baseKey: string
  control: Control<any>
}

export function ArrayFieldItemForm({ field, index, baseKey, control }: ArrayFieldItemFormProps) {
  const { t } = useTranslation()
  const itemFields = getArrayItemFields(field)

  if (itemFields.length === 0) {
    return (
      <p className="text-sm text-muted-foreground pt-2">
        {t('agents.workflow.nodeConfig.array.noItemFields')}
      </p>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 pt-2">
      {itemFields.map((subField: any) => (
        <FormField
          key={`${baseKey}.${index}.${subField.name}`}
          control={control}
          name={`${baseKey}.${index}.${subField.name}`}
          render={({ field: subFormField }) => (
            <FormItem>
              <FormLabel className="text-sm">{subField.label}</FormLabel>
              {subField.type === 'select' ? (
                <Select
                  value={(() => {
                    const raw = subFormField.value;
                    const isPrimitive = typeof raw === 'string' || typeof raw === 'number' || typeof raw === 'boolean';
                    if (raw === '' || raw === null || raw === undefined || !isPrimitive) {
                      return undefined;
                    }
                    return String(raw);
                  })()}
                  onValueChange={(val) => subFormField.onChange(val)}
                >
                  <SelectTrigger className="h-9">
                    <SelectValue placeholder={""} />
                  </SelectTrigger>
                  <SelectContent>
                    {subField.options.map((option: string) => (
                      <SelectItem key={option} value={option}>
                        {option}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Input
                  {...subFormField}
                  type={subField.type === 'number' ? 'number' : 'text'}
                  placeholder={subField.placeholder}
                  className="h-9"
                />
              )}
              {subField.description && (
                <FormDescription className="text-xs">{subField.description}</FormDescription>
              )}
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
    </div>
  )
}
